import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import globalFunctions from '@/utilities/globalFunctions';
import globalVars from '@/utilities/globalVars';
import globalFunctionsEvents from '@/utilities/globalFunctionsEvents';

import SideBar from '@/components/SideBar/SideBar.vue'
import NavBar from '@/components/NavBar/NavBar.vue'
import LoadingPage from '@/components/LoadingPage.vue'

// swal 2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css'; // Importa el estilo por defecto

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

let app = createApp(App)

if (process.env.NODE_ENV === 'production') {
    app.config.devtools = false
}

// Registrar el componente globalmente
app.component('SideBar', SideBar)
app.component('NavBar', NavBar)
app.component('LoadingPage', LoadingPage)
app.component('VueDatePicker', VueDatePicker)
app.component('MultiSelect', Multiselect);

app
.use(store)
.use(router)
.use(VueSweetalert2)
.use(globalFunctions)
.use(globalVars)
.use(globalFunctionsEvents)
.use(VueToast)
.use(VueTelInput)
.mount('#app')